__turbopack_context__.v({
  "content": "message-content-module__9rBBaa__content",
  "table": "message-content-module__9rBBaa__table",
});
